<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <path
      d="M15 15H17C18.1046 15 19 14.1046 19 13V9C19 7.89543 18.1046 7 17 7H3C1.89543 7 1 7.89543 1 9V13C1 14.1046 1.89543 15 3 15H5M7 19H13C14.1046 19 15 18.1046 15 17V13C15 11.8954 14.1046 11 13 11H7C5.89543 11 5 11.8954 5 13V17C5 18.1046 5.89543 19 7 19ZM15 7V3C15 1.89543 14.1046 1 13 1H7C5.89543 1 5 1.89543 5 3V7H15Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: 20,
  },
  height: {
    type: [String, Number],
    default: 20,
  },
  color: {
    type: String,
    default: "black",
  },
});
</script>
